import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { ILocale } from '../../../models/i18n.model';
import Button from '../../Button';
import { Descriptions } from 'antd';
import useAuth from '../../../hooks/useAuth';

interface IProps {
  locale: ILocale | null;
  onSubmit: Function;
}

const SystemLocaleEditor: FC<IProps> = ({ locale, onSubmit }) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const location = useLocation();

  const [code, setCode] = useState('');
  const [korean, setKorean] = useState('');
  const [english, setEnglish] = useState('');

  const codeInput = useRef<any>();
  const koreanInput = useRef<any>();
  const englishInput = useRef<any>();

  useEffect(() => {
    if (locale) {
      setCode(locale.localeSymbol);
      setKorean(locale.korName);
      setEnglish(locale.engName);
    }
  }, [locale])

  const onSave = async () => {
    if (!code) {
      codeInput.current.focus();
      return enqueueSnackbar(t('system.locale.message1'), {
        variant: 'info'
      });
    }
    if (!korean) {
      koreanInput.current.focus();
      return enqueueSnackbar(t('system.locale.message2'), {
        variant: 'info'
      });
    }
    if (!english) {
      englishInput.current.focus();
      return enqueueSnackbar(t('system.locale.message3'), {
        variant: 'info'
      });
    }

    onSubmit({
      localeSymbol: code,
      korName: korean,
      engName: english
    })
  }

  return (
    <div className='comm-table__area rowType edit'>
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label={t('system.locale.column2')}>
          <input
            type="text"
            className="form-control input-text"
            value={code}
            onChange={e => setCode(e.target.value)}
            ref={codeInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('system.locale.column3')}>
          <input
            type="text"
            className="form-control input-text"
            value={korean}
            onChange={e => setKorean(e.target.value)}
            ref={koreanInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('system.locale.column4')}>
          <input
            type="text"
            className="form-control input-text"
            value={english}
            onChange={e => setEnglish(e.target.value)}
            ref={englishInput}
          />
        </Descriptions.Item>
      </Descriptions>

      <div className='comm-bx__space'>
        <div className="comm-btn__area right">
          <Button
            onClick={onSave}
            className="btn-basic pink"
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            onClick={() => history.push(`/system/locale${location.search}`)}
            className="btn-basic gray"
            text={t('common.button.cancel')}
          />
        </div>
      </div>
    </div>    
  )
}

export default SystemLocaleEditor;
